import { buildUrl } from "../../../helpers/apiHelper";
import axios from "../../../lib/axios"

const getGradeCodes = async (
    config,
    options = {
        with: [],
        where: {}
    }
) => {
    const baseUrl = '/api/grade-codes';

    return await axios
        .get(buildUrl(baseUrl, options), config)
        .then(({ data }) => data)
        .catch(({ response }) => {
            console.error(response)
            return []
        })
}

const gradeCodesAPI = {
    getGradeCodes
}

export default gradeCodesAPI
